"use strict";

exports.__esModule = true;
exports.createBandScale = createBandScale;
var _d3Scale = require("d3-scale");
/**
 * Create a band scale.
 * In effect scaleBand will split the range into n bands (where n is the number of values in the domain array) and compute the positions and widths of the bands taking into account any specified padding.
 */
function createBandScale(from, to, values, padding) {
  if (padding === void 0) {
    padding = 0.1;
  }
  return (0, _d3Scale.scaleBand)().range([from, to]).padding(padding).domain(values);
}